import React, { useState, useRef } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import RemoveCircleOutlinedIcon from "@mui/icons-material/RemoveCircleOutlined";
import Typography from "@mui/material/Typography";
import { toast } from "react-toastify";
import { LuImage } from "react-icons/lu";
import { useLanguageContext } from "../../Context/LanguageContext";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

export default function FileUploadDragDrop({
  isOpen,
  setShowFileUploadDialog,
  title,
  description,
  dragAndDropTitle,
  browseButtonTitle,
  type,
  uploadHandler,
}) {
  const [open, setOpen] = React.useState(isOpen);
  const { localization } = useLanguageContext();

  let equipmentImageListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  let equipmentFileListInitState = {
    dropDepth: 0,
    inDropZone: false,
    fileList: [],
    filetoStringarray: [],
  };
  const [equipmentImagesData, setEquipmentImagesData] = useState(
    equipmentImageListInitState,
  );
  const [equipmentFilesData, setEquipmentFilesData] = useState(
    equipmentFileListInitState,
  );
  const ImageFileInputRef = useRef(null);
  const FileInputRef = useRef(null);

  const handleSave = () => {
    if (type == "Images") {
      uploadHandler(equipmentImagesData);
    } else {
      uploadHandler(equipmentFilesData);
    }
  };

  const handleClose = () => {
    setOpen(false);
    setShowFileUploadDialog(false);
  };

  const handleDrop = (event, type) => {
    event.preventDefault();
    event.stopPropagation(); //make sure the event is not propagated from child to parent

    var files = [...event.dataTransfer.files]; // convert the values to a js array
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));

      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
              }));
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });

      event.dataTransfer.clearData();
      if (type == "Images") {
        setEquipmentImagesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      } else {
        setEquipmentFilesData((prevState) => ({
          ...prevState,
          dropDepth: 0,
          inDropZone: false,
        }));
      }
    }
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    e.dataTransfer.dropEffect = "copy";
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: true,
      }));
    }
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth + 1,
      }));
    }
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (type == "Images") {
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentImagesData.dropDepth > 0) return;
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    } else {
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        dropDepth: prevState.dropDepth - 1,
      }));
      if (equipmentFilesData.dropDepth > 0) return;
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        inDropZone: false,
      }));
    }
  };

  const equipmentFilesHandleOnchange = (event, type) => {
    var files = [...event.target.files];
    var fileName = "";
    var fileExtension = "";
    if (files && files.length > 0) {
      files.map((file) => {
        if (type === "Images" && !file.type.startsWith("image/")) {
          toast.error(localization.onlyImagesAllowed);
          return false;
        }

        if (type === "Files") {
          fileName = file.name;
          fileExtension = fileName.split(".").pop().toLowerCase();
          if (fileExtension === "exe" || fileExtension === "bat") {
            toast.error(localization.executableFilesNotAllowed);
            return false;
          }
        }
      });
      const existingFiles =
        type == "Images"
          ? equipmentImagesData.fileList.map((f) => f.name)
          : equipmentFilesData.fileList.map((f) => f.name);
      files = files.filter((f) => !existingFiles.includes(f.name));
      files.forEach((element) => {
        let reader = new FileReader();
        reader.onload = () => {
          if (type == "Images") {
            if (element.type.startsWith("image/")) {
              setEquipmentImagesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }

            if (ImageFileInputRef.current) {
              ImageFileInputRef.current.value = ""; // Clear the input value
            }
          } else {
            fileName = element.name;
            fileExtension = fileName.split(".").pop().toLowerCase();
            if (fileExtension != "exe" && fileExtension != "bat") {
              setEquipmentFilesData((prevState) => ({
                ...prevState,
                fileList: prevState.fileList.concat(element),
                filetoStringarray: prevState.filetoStringarray.concat({
                  Filename: element.name,
                  Filecontent: reader.result,
                  Filetyp: element.type,
                }),
                dropDepth: 0,
                inDropZone: false,
              }));
            }

            if (FileInputRef.current) {
              FileInputRef.current.value = ""; // Clear the input value
            }
          }
        };
        reader.onerror = () => {};
        reader.readAsDataURL(element);
      });
    }
  };

  const removeFiles = (type, fileName) => {
    if (type == "Images") {
      let tempFiles = { ...equipmentImagesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentImagesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    } else {
      let tempFiles = { ...equipmentFilesData };
      let files = tempFiles.fileList.filter((f) => f.name != fileName);
      let filesToStrArray = tempFiles.filetoStringarray.filter(
        (f) => f.Filename != fileName,
      );
      setEquipmentFilesData((prevState) => ({
        ...prevState,
        fileList: files,
        filetoStringarray: filesToStrArray,
      }));
    }
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
          {/* {title}
          <p>{description}</p> */}
          <Typography gutterBottom variant="h4" component="div">
            {title}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {description}
          </Typography>
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={(theme) => ({
            position: "absolute",
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div className="pictureContainer">
            <div
              className=""
              onDrop={(e) => handleDrop(e, type)}
              onDragOver={(e) => handleDragOver(e, type)}
              onDragEnter={(e) => handleDragEnter(e, type)}
              onDragLeave={(e) => handleDragLeave(e, type)}
            >
              {equipmentImagesData.filetoStringarray &&
              equipmentImagesData.filetoStringarray.length > 0 ? (
                <>
                  <ul className="fileList">
                    {equipmentImagesData.fileList.map((f, index) => {
                      return (
                        <li key={index}>
                          {f.name}{" "}
                          <span
                            className="float-right removeFileIconCls"
                            onClick={() => {
                              removeFiles(type, f.name);
                            }}
                          >
                            <RemoveCircleOutlinedIcon fontSize="large" />
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : (
                <></>
              )}

              {equipmentFilesData.filetoStringarray &&
              equipmentFilesData.filetoStringarray.length > 0 ? (
                <>
                  <ul className="fileList">
                    {equipmentFilesData.fileList.map((f, index) => {
                      return (
                        <li key={index}>
                          {f.name}{" "}
                          <span
                            className="float-right removeFileIconCls"
                            onClick={() => {
                              removeFiles(type, f.name);
                            }}
                          >
                            <RemoveCircleOutlinedIcon fontSize="large" />
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </>
              ) : (
                <></>
              )}

              <div>
                <div className="pb-4">
                  {type == "Images" ? (
                    <LuImage style={{ fontSize: "30px" }} />
                  ) : (
                    <></>
                  )}
                </div>
                <div>{dragAndDropTitle}</div>
              </div>
              <div className="BrowseBtnContainer">
                <input
                  type="file"
                  ref={type == "Images" ? ImageFileInputRef : FileInputRef}
                  className=""
                  accept={type == "Images" ? "image/*" : ""}
                  onChange={(e) => {
                    equipmentFilesHandleOnchange(e, type);
                  }}
                  multiple
                />
                <div className="Browsebtn">
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary" }}
                    className="py-4"
                  >
                    {localization.or}
                  </Typography>
                  {/* <div className="py-4">{localization.or}</div> */}
                  <Button
                    variant="contained"
                    className="containedBtnCls"
                    sx={{ textTransform: "none" }}
                    size="large"
                  >
                    {browseButtonTitle}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            className="containedBtnCls"
            sx={{ textTransform: "none" }}
            size="large"
            autoFocus
            onClick={handleSave}
          >
            {localization.upload}
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
}
